module.exports = __webpack_public_path__ + "static/media/asset.3c9ac0b3.png";